import React,{useState} from "react";
import { makeAPI } from "../../services/api";
export default function TournamentRegistrationPopup({ onRegister, onClose, game_id, game_name, event_id }) {
    const [inputGamerId, setInputGamerId] = useState("");
    parseInt(event_id);
    const handleSubmit = async (e) => {
        e.preventDefault(); 
        document.activeElement.blur(); // Remove focus from the button after click
        document.querySelector('.uk-margin-small-bottom').style.pointerEvents = 'none'; // Disable the button to prevent multiple clicks
        if (inputGamerId.trim() === "") {
            $('#uname_valid_msg').html('*Enter your Gamer Handle!');
            $('#uname_valid_msg').css('padding-top', '5px');
            $('#uname_valid_msg').css('color', 'red');
            setTimeout(() => {
                $('#uname_valid_msg').html('');
            }, 2000);
            return;
        }
        else {
            // Ensure username with chess API
            try {
                let username = inputGamerId.trim();
                const response = await makeAPI('/api/username_validate', 'post', false, { username, game_id, event_id });
                if (response.status === 'E') {
                    throw new Error(response.message);
                }
                onClose();
                onRegister(username); // Pass the gamer ID to the parent
            }

            catch (error) {
                console.log(error);
                $('#uname_valid_msg').html(error.message || 'Gamer Handle not found');
                $('#uname_valid_msg').css('padding-top', '5px');
                $('#uname_valid_msg').css('color', 'red');
                setTimeout(() => {
                    $('#uname_valid_msg').html('');
                    document.querySelector('.uk-margin-small-bottom').style.pointerEvents = 'auto'; // Re-enable the button after error message disappears
                }, 2300);
            }
        }


    };
    function gamerHandleValidator(e) {
        if (game_id === 3 || game_id === 2) {
            // Add '#' prefix for game_id 3
            const value = e.target.value;
            if (!value.startsWith('#')) {
                e.target.value = `#${value.replace(/^#+/, '')}`; // Ensure only one '#' at the start
            }
            setInputGamerId(e.target.value);
        } else {
            e.target.value = e.target.value.toLowerCase();
            setInputGamerId(e.target.value);
        }
    }
    return (
        <>

            <div className="page-modals">
                <div className="uk-flex-top d-flex  opacity-100" id="modal-report" data-uk-modal>
                    <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical opacity-100" style={{ transform: "none" }}><button className="uk-modal-close-default bg-light text-dark" type="button" data-uk-close onClick={onClose} ></button>
                        <h2 className="uk-modal-title">Registration Popup</h2>
                        <div className="uk-form-stacked">
                            <h6>Welcome to Register <span style={{ color: "var(--main-color-one)" }}>{game_name?.charAt(0)?.toUpperCase() + game_name?.slice(1)}</span> Tournament</h6>
                            <div className="search">
                                <div className="search__input"><i className=""></i><input type="text" name="search" placeholder="Enter your Game username" onChange={(e) => { gamerHandleValidator(e) }} /></div>
                            </div>
                           <small style={{ textAlign: 'left' }} id='uname_valid_msg'></small><br/>
                            <small className="game-card__genre" style={{ fontSize: "11px" }}>
                                Note: You only need to add your gamer name once.
                                To change it, visit Account Section.
                            </small>

                            <br /> <br />
                            {game_id === 1 ? (<div className="row" >
                                <div className="">
                                    <h3 className="mt-0 m-0 tour-detail-small-text" style={{ color: "var(--main-color-one)" }}>Step 1</h3>
                                    <ol className="mt-0 m-0 game-card__genre">
                                        <li>Open <strong>Chess.com</strong> and log in.</li>
                                        <li>
                                            Go to your <strong>Profile</strong>:
                                            <ul>
                                                <li>📱 Mobile → Tap ☰ Menu and select your profile.</li>
                                                <li>💻 Desktop → Click your profile picture or name at the top.</li>
                                            </ul>
                                        </li>
                                    </ol>
                                    <h5 className="mt-0 m-0 tour-detail-small-text" style={{ color: "var(--main-color-one)" }}>Step 2</h5>
                                    <ol start="3" className="mt-0 m-0 game-card__genre">
                                        <li>Find your <strong>Username (Gamer Name)</strong> on your profile page.</li>
                                        <li>Copy the username.</li>
                                        <li>Paste it into our <strong>Tournament Registration Form</strong>.</li>
                                    </ol>
                                </div>
                            </div>) : game_id === 3 ? (<div className="row" >
                                <div className="">
                                    <h3 className="mt-0 m-0 tour-detail-small-text" style={{ color: "var(--main-color-one)" }}>Step 1</h3>
                                    <ol className="mt-0 m-0 game-card__genre" style={{paddingBottom:"12px"}}>
                                        <li>Open <strong>Clash Royale</strong> </li>
                                        <li>
                                            Go to the Battle section and tap the Trophy icon.
                                        </li>
                                    </ol>
                                    <h5 className="mt-0 m-0 tour-detail-small-text" style={{ color: "var(--main-color-one)" }}>Step 2</h5>
                                    <ol className="mt-0 m-0 game-card__genre">
                                        <li>Find your Gamer Name on the screen.</li>
                                        <li>Copy the username.</li>
                                        <li>Paste it into our <strong>Tournament Registration Form</strong>.</li>
                                    </ol>
                                </div>
                            </div>) :
                                null}
                            <br />
                            <a className="uk-button  uk-button-theme-color uk-width-1-1 uk-margin-small-bottom" style={{ border: "1px solid #e2e2e241" }} onClick={(e) => { handleSubmit(e) }}>Submit</a>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}